import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2LevelUpAnimDialogProperties extends BasicDialogProperties {
    public chips: number = NaN;
    public gold: number = NaN;

    constructor(chips: number, gold: number) {
        super();

        this.chips = chips;
        this.gold = gold;
    }
}
